/* eslint-disable */
import React, { useCallback, useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { HiOutlineCurrencyRupee } from 'react-icons/hi2';
import TagInput from './TagInput';
import UploadFile from '../UploadFile';
import RequirementField from './RequirementField';
import { resetCourseState, setCourseInformation, setStep } from '../../../../../../redux/slices/courseSlice';
import { useNavigate } from 'react-router-dom';
import SubmitButtons from '../SubmitButtons';

const CourseInformation = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [tags, setTags] = useState([]);
    const [requirements, setRequirements] = useState([]);
    const [preview, setPreview] = useState(null);
    const { courseInformation, categories } = useSelector(state => state.course);
    const {
        register,
        control,
        reset,
        handleSubmit,
        setValue,
        formState: { errors }
    } = useForm();

    const onSubmit = (data) => {
        dispatch(setCourseInformation(data));
        dispatch(setStep(2));
    }
    const resetHandler = useCallback(() => {
        reset({
            courseTitle: '',
            courseShortDesc: '',
            coursePrice: '',
            courseTags: [],
            courseBenefits: '',
            courseCategory: '',
            courseRequirements: [],
            courseImage: '',
            courseLanguage: '',
        });
        setTags([]);
        setRequirements([]);
        setPreview(null);
        dispatch(setCourseInformation(null));
    }, [reset]);

    const cancelHandler = () => {
        navigate('/dashboard/profile');
        resetHandler();
        dispatch(resetCourseState());
    }

    useEffect(() => {
        if (courseInformation) {
            setValue('courseTitle', courseInformation?.courseTitle ?? '');
            setValue('courseShortDesc', courseInformation?.courseShortDesc ?? '');
            setValue('coursePrice', courseInformation?.coursePrice ?? '');
            setValue('courseTags', courseInformation?.courseTags ?? []);
            setValue('courseBenefits', courseInformation?.courseBenefits ?? '');
            setValue('courseCategory', courseInformation?.courseCategory ?? '');
            setValue('courseRequirements', courseInformation?.courseRequirements ?? []);
            setValue('courseImage', courseInformation?.courseImage ?? '');
            setValue('courseLanguage', courseInformation?.courseLanguage ?? '');
            setTags(courseInformation?.courseTags ?? []);
            setRequirements(courseInformation?.courseRequirements ?? []);
            setPreview(courseInformation?.courseImage ?? '');
        }
    }, []);

    return (
        <form onSubmit={handleSubmit(onSubmit)} className='w-full flex flex-col md:gap-y-7 gap-y-5'>
            <div>
                <label className='w-full'>
                    <p className='text-[0.875rem] leading-[1.375rem] text-richblack-5 mb-1'>Course Category <sup className='text-pink-200'>*</sup></p>
                    <select
                        className='w-full p-[12px] bg-richblack-800 rounded-[0.5rem] text-richblack-5 outline-none'
                        style={{ boxShadow: 'rgba(255, 255, 255, 0.18) 0px -1px 0px inset' }}
                        id='courseCategory'
                        defaultValue=''
                        {...register('courseCategory', { required: true })}
                    >
                        <option value='' disabled>Choose a Category</option>
                        {categories.map((category) => (
                            <option key={category._id} value={category.name}>{category.name}</option>
                        ))}
                    </select>
                    {errors.courseCategory && <span className='text-pink-200 text-sm'>course category is required</span>}
                </label>
            </div>
            <div>
                <label className='w-full'>
                    <p className='text-[0.875rem] leading-[1.375rem] text-richblack-5 mb-1'>Course Title <sup className='text-pink-200'>*</sup></p>
                    <input
                        className='w-full p-[12px] bg-richblack-800 rounded-[0.5rem] text-richblack-5 outline-none'
                        style={{ boxShadow: 'rgba(255, 255, 255, 0.18) 0px -1px 0px inset' }}
                        type='text'
                        id='courseTitle'
                        placeholder='Enter Course Title'
                        {...register("courseTitle", { required: true })}
                    />
                    {errors.courseTitle && <span className='text-pink-200 text-sm'>course title is required</span>}
                </label>
            </div>
            <div>
                <TagInput
                    label='Tags'
                    name='courseTags'
                    placeholder='Enter Tags....'
                    register={register}
                    errors={errors}
                    setValue={setValue}
                    tags={tags}
                    setTags={setTags}
                />
            </div>
            <div>
                <RequirementField
                    label='Requirements / Instructions'
                    name='courseRequirements'
                    placeholder='Enter Course Requirements....'
                    register={register}
                    errors={errors}
                    setValue={setValue}
                    requirements={requirements}
                    setRequirements={setRequirements}
                />
            </div>
            <div>
                <label className='w-full'>
                    <p className='text-[0.875rem] leading-[1.375rem] text-richblack-5 mb-1'>Course Language <sup className='text-pink-200'>*</sup></p>
                    <select
                        className='w-full p-[12px] bg-richblack-800 rounded-[0.5rem] text-richblack-5 outline-none'
                        style={{ boxShadow: 'rgba(255, 255, 255, 0.18) 0px -1px 0px inset' }}
                        id='courseLanguage'
                        defaultValue=''
                        {...register('courseLanguage', { required: true })}
                    >
                        <option value='' disabled>Course Language</option>
                        <option value='Hindi'>Hindi</option>
                        <option value='English'>English</option>
                    </select>
                    {errors.courseLanguage && <span className='text-pink-200 text-sm'>course language is required</span>}
                </label>
            </div>
            <div>
                <label className='w-full'>
                    <p className='text-[0.875rem] leading-[1.375rem] text-richblack-5 mb-1'>Benefits of the course <sup className='text-pink-200'>*</sup></p>
                    <textarea
                        className='w-full p-[12px] bg-richblack-800 rounded-[0.5rem] h-24 text-richblack-5 outline-none'
                        style={{ boxShadow: 'rgba(255, 255, 255, 0.18) 0px -1px 0px inset' }}
                        placeholder='Enter Benefits of the course'
                        name='courseBenefits'
                        id='courseBenefits'
                        {...register('courseBenefits', { required: true })}
                    />
                    {errors.courseBenefits && <span className='text-pink-200 text-sm'>benefits of the course are required</span>}
                </label>
            </div>
            <div>
                <label className='w-full'>
                    <p className='text-[0.875rem] leading-[1.375rem] text-richblack-5 mb-1'>About Course <sup className='text-pink-200'>*</sup></p>
                    <textarea
                        className='w-full p-[12px] bg-richblack-800 h-40 rounded-[0.5rem] text-richblack-5 outline-none'
                        style={{ boxShadow: 'rgba(255, 255, 255, 0.18) 0px -1px 0px inset' }}
                        id='courseShortDesc'
                        placeholder='Enter Description'
                        {...register("courseShortDesc", { required: true })}
                    />
                    {errors.courseShortDesc && <span className='text-pink-200 text-sm'>course description is required</span>}
                </label>
            </div>
            <div className='relative'>
                <label className='w-full'>
                    <p className='text-[0.875rem] leading-[1.375rem] text-richblack-5 mb-1'>Price <sup className='text-pink-200'>*</sup></p>
                    <Controller
                        name="coursePrice"
                        control={control}
                        defaultValue='0'
                        render={({ field }) => (
                            <input
                                className='w-full pl-9 p-[12px] bg-richblack-800 rounded-[0.5rem] text-richblack-5 outline-none'
                                style={{ boxShadow: 'rgba(255, 255, 255, 0.18) 0px -1px 0px inset' }}
                                {...field}
                                type="text"
                                placeholder="Enter price"
                                onChange={(e) => {
                                    const rawValue = e.target.value.replace(/[^0-9,]/g, '');
                                    const sanitizedValue = rawValue.replace(/,+/g, ',');
                                    const formattedValue = /^\d+$/.test(sanitizedValue) ? new Intl.NumberFormat().format(sanitizedValue) : '0';
                                    field.onChange(formattedValue);
                                }}
                            />
                        )}
                    />
                    <HiOutlineCurrencyRupee className='absolute left-2 top-1/2 text-richblack-300 font-bold text-2xl' />
                </label>
            </div>
            <div>
                <UploadFile
                    label='Course Thumbnail'
                    name="courseImage"
                    placeholder="image"
                    accept="image/*"
                    startsWith='image/'
                    register={register}
                    errors={errors}
                    setValue={setValue}
                    preview={preview}
                    setPreview={setPreview}
                />
            </div>
            <div>
                <SubmitButtons
                    submitText='Next'
                    resetText='Reset'
                    cancelText='Cancel'
                    submitType='submit'
                    resetType='reset'
                    resetHandler={resetHandler}
                    cancelHandler={cancelHandler}
                />
            </div>
        </form>
    )
}

export default CourseInformation;